<!-- cv简历信息表-学分课程-组件级 -->
<template>
  <div class='detail-wrap'>
    <div class='detail-container'>
      <div class='cv-detail cn'
           v-if='!isEditCn && lang==="cn"'>
        <p class='pad-top warning'>注：包括夏校和其他有学分的在线课程，比如Pioneer Academics</p>
        <div v-if='creditDetailCn.credits && creditDetailCn.credits.length > 0'>
          <ul v-for='(item, index) in creditDetailCn.credits'
              :key='index'>
            <li>
              <span class='cv-detail-name'>持续时间：</span>
              <span class='cv-detail-val'>{{item.time && item.time[0] && item.time[1] && `${item.time[0]} 至 ${item.time[1]}`}}</span>
            </li>
            <li>
              <span class='cv-detail-name'>学校名称：</span>
              <span class='cv-detail-val'>{{item.school}}</span>
            </li>
            <li>
              <span class='cv-detail-name'>地址：</span>
              <span class='cv-detail-val'>{{item.address}}</span>
            </li>
            <li class='sub-list'
                v-if='item.course && item.course.length > 0'>
              <div v-for='(subItem, subIndex) in item.course'
                   :key="`${index}-${subIndex}`">
                <div class='sub-item'>
                  <span class='cv-detail-name'>选修课程名称：</span>
                  <span class='cv-detail-val'>{{subItem.courseName}}</span>
                </div>
                <div class='sub-item'>
                  <span class='cv-detail-name'>学分：</span>
                  <span class='cv-detail-val'>{{subItem.credit}}</span>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class='cv-detail en'
           v-if='!isEditEn && lang==="en"'>
        <p class='pad-top warning'>*Including summer programs and online classes that award college credits, like Pioneer Academics</p>
        <div v-if='creditDetailEn.credits && creditDetailEn.credits.length > 0'>
          <ul v-for='(item, index) in creditDetailEn.credits'
              :key='index'>
            <li>
              <span class='cv-detail-name'>Length of course：</span>
              <span class='cv-detail-val'>{{item.time && item.time[0] && item.time[1] && `${item.time[0]} to ${item.time[1]}`}}</span>
            </li>
            <li>
              <span class='cv-detail-name'>Name of School：</span>
              <span class='cv-detail-val'>{{item.school}}</span>
            </li>
            <li>
              <span class='cv-detail-name'>Address：</span>
              <span class='cv-detail-val'>{{item.address}}</span>
            </li>
            <li class='sub-list'
                v-if='item.course && item.course.length > 0'>
              <div v-for='(subItem, subIndex) in item.course'
                   :key="`${index}-${subIndex}`">
                <div class='sub-item'>
                  <span class='cv-detail-name'>Name of Course taken：</span>
                  <span class='cv-detail-val'>{{subItem.courseName}}</span>
                </div>
                <div class='sub-item'>
                  <span class='cv-detail-name'>Credit Received：</span>
                  <span class='cv-detail-val'>{{subItem.credit}}</span>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class='cv-form cn'
           v-if='isEditCn && lang==="cn"'>
        <Form ref="formValidateCn"
              :model="formValidateCn"
              :rules="ruleValidateCn"
              :label-width="300">

          <div class="base-form-item-wrap">
            <p class='pad-top warning'>注：包括夏校和其他有学分的在线课程，比如Pioneer Academics</p>
            <div class="base-form-item-list"
                 v-if='formValidateCn.credits && formValidateCn.credits.length > 0'>
              <div class="base-form-item"
                   v-for='(item, index) in formValidateCn.credits'
                   :key='index'>
                <FormItem label="持续时间："
                          :prop="`credits.${index}.time`"
                          :rules="[{required: true, message: '请选择'}]">
                  <DatePicker type="daterange"
                              :editable='false'
                              placeholder="请选择"
                              v-model="item.time"
                              style="width:100%;"></DatePicker>
                </FormItem>
                <FormItem label="学校名称："
                          :prop="`credits.${index}.school`"
                          :rules="[{required: true, message: '请输入学校名称'}]">
                  <Input v-model="item.school"
                         placeholder="请输入学校名称"
                         clearable></Input>
                </FormItem>
                <FormItem label="地址："
                          :prop="`credits.${index}.address`"
                          :rules="[{required: true, message: '请输入地址'}]">
                  <Input type='textarea'
                         :rows='5'
                         v-model="item.address"
                         placeholder="请输入地址"></Input>
                </FormItem>
                <div class="base-form-item-list"
                     v-if='item.course && item.course.length > 0'>
                  <div class="base-form-item"
                       v-for='(subItem, subIndex) in item.course'
                       :key='`${index}-${subIndex}`'>
                    <FormItem label="选修课程名称："
                              :prop="`credits.${index}.course.${subIndex}.courseName`"
                              :rules="[{required: true, message: '请输入选修课程名称'}]">
                      <Input v-model="subItem.courseName"
                             placeholder="请输入选修课程名称"
                             clearable></Input>
                    </FormItem>
                    <FormItem label="学分："
                              :prop="`credits.${index}.course.${subIndex}.credit`"
                              :rules="[
                                {required: true, message: '请输入学分'},
                                {pattern: /^\d+(\.\d+)?$/, message: 'Please fill the test score'}
                              ]">
                      <Input v-model="subItem.credit"
                             placeholder="请输入学分"
                             clearable></Input>
                    </FormItem>
                    <div class='oper-del'>
                      <a href='javascript: void(0)'
                         @click="subDelCn(item, index, subItem, subIndex)">删除课程</a>
                    </div>
                  </div>
                </div>
                <div class='oper-add'>
                  <a href='javascript: void(0)'
                     @click="subAddCn(item, index)">添加课程</a>
                </div>
                <div class='oper-del'>
                  <a href='javascript: void(0)'
                     @click="delCn(item, index)">删除</a>
                </div>
              </div>
            </div>
            <div class='oper-del'>
              <a href='javascript: void(0)'
                 @click="addCn()">添加</a>
            </div>
          </div>
          <div class="sub-btn">
            <Button type='primary'
                    :loading='hasSaveCn'
                    @click="saveCn">保存</Button>
          </div>
        </Form>
      </div>
      <div class='cv-form en'
           v-if='isEditEn && lang==="en"'>
        <Form ref="formValidateEn"
              :model="formValidateEn"
              :rules="ruleValidateEn"
              :label-width="300">

          <div class="base-form-item-wrap">
            <p class='pad-top warning'>*Including summer programs and online classes that award college credits, like Pioneer Academics</p>
            <div class="base-form-item-list"
                 v-if='formValidateEn.credits && formValidateEn.credits.length > 0'>
              <div class="base-form-item"
                   v-for='(item, index) in formValidateEn.credits'
                   :key='index'>
                <FormItem label="Length of course："
                          :prop="`credits.${index}.time`"
                          :rules="[{required: true, message: 'Please select'}]">
                  <DatePicker type="daterange"
                              :editable='false'
                              placeholder="Please select"
                              v-model="item.time"
                              style="width:100%;"></DatePicker>
                </FormItem>
                <FormItem label="Name of School："
                          :prop="`credits.${index}.school`"
                          :rules="[{required: true, message: 'Please enter name of school'}]">
                  <Input v-model="item.school"
                         placeholder="Please enter name of school"
                         clearable></Input>
                </FormItem>
                <FormItem label="Address："
                          :prop="`credits.${index}.address`"
                          :rules="[{required: true, message: 'Please enter address'}]">
                  <Input type='textarea'
                         :rows='5'
                         v-model="item.address"
                         placeholder="Please enter address"></Input>
                </FormItem>
                <div class="base-form-item-list"
                     v-if='item.course && item.course.length > 0'>
                  <div class="base-form-item"
                       v-for='(subItem, subIndex) in item.course'
                       :key='`${index}-${subIndex}`'>
                    <FormItem label="Name of Course taken："
                              :prop="`credits.${index}.course.${subIndex}.courseName`"
                              :rules="[{required: true, message: 'Please enter name of course taken'}]">
                      <Input v-model="subItem.courseName"
                             placeholder="Please enter name of course taken"
                             clearable></Input>
                    </FormItem>
                    <FormItem label="Credit Received："
                              :prop="`credits.${index}.course.${subIndex}.credit`"
                              :rules="[
                                {required: true, message: 'Please enter credit'},
                                {pattern: /^\d+(\.\d+)?$/, message: 'Please fill the test score'}
                              ]">
                      <Input v-model="subItem.credit"
                             placeholder="Please enter credit"
                             clearable></Input>
                    </FormItem>
                    <div class='oper-del'>
                      <a href='javascript: void(0)'
                         @click="subDelEn(item, index, subItem, subIndex)">Delete Course</a>
                    </div>
                  </div>
                </div>
                <div class='oper-add'>
                  <a href='javascript: void(0)'
                     @click="subAddEn(item, index)">Add Course</a>
                </div>
                <div class='oper-del'>
                  <a href='javascript: void(0)'
                     @click="delEn(item, index)">Delete</a>
                </div>
              </div>
            </div>
            <div class='oper-del'>
              <a href='javascript: void(0)'
                 @click="addEn()">Add</a>
            </div>
          </div>
          <div class="sub-btn">
            <Button type='primary'
                    :loading='hasSaveEn'
                    @click="saveEn">Save</Button>
          </div>
        </Form>
      </div>
      <div class='cv-btn cn'
           v-if='lang==="cn"'>
        <a href='javascript: void(0)'
           @click="goEditCn">{{isEditCn ? '返回' : '编辑'}}</a>
      </div>
      <div class='cv-btn en'
           v-if='lang==="en"'>
        <a href='javascript: void(0)'
           @click="goEditEn">{{isEditEn ? 'back' : 'Edit'}}</a>
      </div>
    </div>
  </div>
</template>

<script>
import cvService from '@/api/undergraduate/cv'
import { proficiencyCnMap, proficiencyEnMap, proTrainingCnMap, proTrainingEnMap } from '../constants'
import dayjs from 'dayjs'
import './cv-detail.less'
export default {
  name: '',
  props: {
    lang: {
      type: String,
      default: ''
    }
  },
  components: {},
  data () {
    return {
      // 熟练程度映射
      proficiencyCnMap,
      proficiencyEnMap,
      // 是否专业训练映射
      proTrainingCnMap,
      proTrainingEnMap,
      // 是否编辑状态标识
      isEditEn: false,
      isEditCn: false,
      // 学分课程信息详情
      creditDetailCn: {},
      creditDetailEn: {},
      // Cn表单
      formValidateCn: {
        credits: [
          {
            course: []
          }
          // {
          //   time: ['', ''],
          //   startTime: '',
          //   endTime: '',
          //   school: '',
          //   address: '',
          // course: [
          //     {
          //       courseName: '',
          //       credit: ''
          //     }
          //   ]
          // }
        ]
      },
      ruleValidateCn: {},
      // En表单
      formValidateEn: {
        credits: [
          // {
          //   time: ['', ''],
          //   startTime: '',
          //   endTime: '',
          //   school: '',
          //   address: '',
          //   course: [
          //     {
          //       courseName: '',
          //       credit: ''
          //     }
          //   ]
          // }
        ]
      },
      ruleValidateEn: {},
      // loading-表单提交-避免重复提交
      hasSaveCn: false,
      hasSaveEn: false
    }
  },
  computed: {},
  mounted () {
    this.$nextTick(() => {
      if (this.lang === 'cn') {
        this.getCreditDetailCn()
      }
      if (this.lang === 'en') {
        this.getCreditDetailEn()
      }
    })
  },
  methods: {
    // 获取学分课程信息-cn
    getCreditDetailCn () {
      cvService.cvCreditDetailCn().then(res => {
        let data = res.data.model
        let temp = res.data.model
        // 处理时间-有些粗糙
        if (temp) {
          if (temp.credits && temp.credits.length > 0) {
            temp.credits.map((item, index) => {
              if (data.credits[index].time && data.credits[index].time.length > 0) {
                data.credits[index].time[0] = dayjs(item.time[0]).format('YYYY-MM-DD')
                data.credits[index].time[1] = dayjs(item.time[1]).format('YYYY-MM-DD')
              }
              return item
            })
          }
          this.creditDetailCn = data
          this.formValidateCn = data
        }
      }).catch(error => {
        this.$ugd_message(error.message, 'error')
      })
    },
    // 获取学分课程信息-en
    getCreditDetailEn () {
      cvService.cvCreditDetailEn().then(res => {
        let data = res.data.model
        let temp = res.data.model
        // 处理时间-有些粗糙
        if (temp) {
          if (temp.credits && temp.credits.length > 0) {
            temp.credits.map((item, index) => {
              if (data.credits[index].time && data.credits[index].time.length > 0) {
                data.credits[index].time[0] = dayjs(item.time[0]).format('YYYY-MM-DD')
                data.credits[index].time[1] = dayjs(item.time[1]).format('YYYY-MM-DD')
              }
              return item
            })
          }
          this.creditDetailEn = data
          this.formValidateEn = data
        }
      }).catch(error => {
        this.$ugd_message(error.message, 'error')
      })
    },
    // 编辑-返回
    goEditCn () {
      this.isEditCn = !this.isEditCn
      this.getCreditDetailCn()
    },
    // edit-back
    goEditEn () {
      this.isEditEn = !this.isEditEn
      this.getCreditDetailEn()
    },
    // 课程删除
    subDelCn (item, index, subItem, subIndex) {
      this.formValidateCn.credits[index].course.splice(subIndex, 1)
    },
    // 课程添加
    subAddCn (item, index) {
      this.formValidateCn.credits[index].course.push({
        courseName: '',
        credit: ''
      })
    },
    // 删除
    delCn (item, index) {
      this.formValidateCn.credits.splice(index, 1)
    },
    // 添加
    addCn () {
      this.formValidateCn.credits.push({
        time: ['', ''],
        school: '',
        address: '',
        course: []
      })
    },
    // Delete Course
    subDelEn (item, index, subItem, subIndex) {
      this.formValidateEn.credits[index].course.splice(subIndex, 1)
    },
    // Add Course
    subAddEn (item, index) {
      this.formValidateEn.credits[index].course.push({
        courseName: '',
        credit: ''
      })
    },
    // Delete
    delEn (item, index) {
      this.formValidateEn.credits.splice(index, 1)
    },
    // 添加
    addEn () {
      this.formValidateEn.credits.push({
        time: ['', ''],
        school: '',
        address: '',
        course: []
      })
    },
    // 保存
    saveCn () {
      if (this.creditDetailCn.credits && this.creditDetailCn.credits.length === 0) {
        this.hasSaveCn = true
        // 调用接口
        cvService.cvSaveCreditCn(this.formValidateCn).then(res => {
          this.hasSaveCn = false
          this.isEditCn = false
          this.$ugd_message('保存成功', 'success')
          this.getCreditDetailCn()
          // 调用详情接口
        }).catch(error => {
          this.hasSaveCn = false
          this.$ugd_message(error.message, 'error')
        })
        return
      }
      this.$refs.formValidateCn.validate((valid) => {
        if (valid) {
          // 时间段校验必填
          if (this.formValidateCn.credits.findIndex(item => item.time[0] === '') !== -1) {
            this.$ugd_message('请选择持续时间', 'error')
            return
          }
          this.hasSaveCn = true
          // 调用接口
          cvService.cvSaveCreditCn(this.formValidateCn).then(res => {
            this.hasSaveCn = false
            this.isEditCn = false
            this.$ugd_message('保存成功', 'success')
            this.getCreditDetailCn()
            // 调用详情接口
          }).catch(error => {
            this.hasSaveCn = false
            this.$ugd_message(error.message, 'error')
          })
        }
      })
    },
    // Save
    saveEn () {
      if (this.creditDetailEn.credits && this.creditDetailEn.credits.length === 0) {
        this.hasSaveEn = true
        // 调用接口
        cvService.cvSaveCreditEn(this.formValidateEn).then(res => {
          this.hasSaveEn = false
          this.isEditEn = false
          this.$ugd_message('Save Success', 'success')
          this.getCreditDetailEn()
          // 调用详情接口
        }).catch(error => {
          this.hasSaveEn = false
          this.$ugd_message(error.message, 'error')
        })
        return
      }
      this.$refs.formValidateEn.validate((valid) => {
        if (valid) {
          // 时间段校验必填
          if (this.formValidateEn.credits.findIndex(item => item.time[0] === '') !== -1) {
            this.$ugd_message('Please select length of course', 'error')
            return
          }
          this.hasSaveEn = true
          // 调用接口
          cvService.cvSaveCreditEn(this.formValidateEn).then(res => {
            this.hasSaveEn = false
            this.isEditEn = false
            this.$ugd_message('Save Success', 'success')
            this.getCreditDetailEn()
            // 调用详情接口
          }).catch(error => {
            this.hasSaveEn = false
            this.$ugd_message(error.message, 'error')
          })
        }
      })
    }
  }
}
</script>
<style lang='less' scoped>
</style>
